import React from 'react'
import Header from '../common/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { startLoader, stopLoader } from '../../_store/reducers/loaderReducer'
import { useDispatch } from 'react-redux'
import { notifyError } from '../helper/Toaster'
import { deleteAuthToken } from '../../utils/helper'
import { getAllTeachersAdmin } from '../../requests'
import SearchableDropdown from '../common/SearchableDropdown'
import Nodata from '../common/Nodata'


const Teachers = () => {
  const dispatch = useDispatch()
    const navigate = useNavigate()
    const {school_code, school_name, school_id} = useLocation().state
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5)
    const [totalCount, setTotalCount] = useState(0)
    const [teachers, setTeachers] = useState([])
    const [subjects, setSubjects] = useState([])
    const [grades, setGrades] = useState([])
    const [subject, setSubject] = useState("")
    const [grade, setGrade] = useState("")
    const [noData, setNoData] = useState(false)

    // const teachers = [
    //     {
    //         teacher_name: "John Doe",
    //         teacher_email: "john.doe@example.com",
    //         subject: "Math",
    //         position: "Teacher",
    //         total_evaluations: 5,
    //     },
    //     {
    //         teacher_name: "Jane Doe",
    //         teacher_email: "jane.doe@example.com",
    //         subject: "Science",
    //         position: "Coordinator",
    //         total_evaluations: 5,
    //     },
    //     {
    //         teacher_name: "Jim Doe",
    //         teacher_email: "jim.doe@example.com",
    //         subject: "History",
    //         position: "Head Teacher",
    //         total_evaluations: 5,
    //     },
    //     {
    //         teacher_name: "Jill Doe",
    //         teacher_email: "jill.doe@example.com",
    //         subject: "English",
    //         position: "Teacher",
    //         total_evaluations: 5,
    //     },
    //     {
    //         teacher_name: "Jack Doe",
    //         teacher_email: "jack.doe@example.com",
    //         subject: "Physics",
    //         position: "Teacher",
    //         total_evaluations: 5,
    //     },
    // ]


    const getAllTeachers = async (pageVal) =>{
      if(!school_id) {
        return;
      }

        dispatch(startLoader())
        try {
            const response = await getAllTeachersAdmin({page: pageVal, limit: limit, school_id: school_id, subject: subject == 'All subjects' ? '' : subject, grade: grade == 'All grades' ? '' : grade});
         
            if(response.status == 200){
              setTeachers(response.data.data);
              if(response.data.data.length == 0){
                setNoData(true)
              }
              else{
                setNoData(false)
              }
              setSubjects(['All subjects',...response.data.subjects]);
              setGrades(['All grades',...response.data.grades]); 
              setTotalCount(response.data.totalCount);
            }
        } catch (error) {
            if(error?.response?.status == 403){
                notifyError(error?.response?.data?.error ||"Your session has expired. Please log in again.")
                deleteAuthToken()
                navigate('/login')
                return;
            }
            notifyError(error?.response?.data?.error || "Something went wrong");
            console.log(error);
        } finally {
            dispatch(stopLoader())
        }
    }

    useEffect(() => {
        setPage(1)
        getAllTeachers(1)
    }, [school_id,grade,subject])

    useEffect(() => {
        getAllTeachers(page)
    }, [page])
  return (
    <div className='page-main'>
        <Header name = {["School Management","Teachers"]} />
        <div className='tm-main'>
            <div className="overview-head">
                <div className="overview-head-left">Teachers of {school_name}

                  <div style={{fontSize: '14px', color: '#6B7280'}}>School Code: {school_code}</div>
                </div>

                <div className="overview-head-right">
                  <SearchableDropdown
                    options={[...subjects]}
                    selected={subject}
                    setSelected={(e) => setSubject(e)}
                    color="#E5E7EB"
                    placeHolder='Enter subject'
                  />
                  <SearchableDropdown
                    options={[...grades]}
                    selected={grade}
                    setSelected={(e) => setGrade(e)}
                    color="#E5E7EB"
                    placeHolder='Enter grade'
                  />
                </div>


            </div>

            <div className="ai-fd-table">
        <div className="ai-fd-table-head">
          <div className="ai-fd-head-cell" style={{ width: "15%" }}>
          Name
          </div>
          <div className="ai-fd-head-cell" style={{ width: "20%" }}>
            Email
          </div>
          <div className="ai-fd-head-cell" style={{ width: "15%" }}>
           Subject
          </div>
          <div className="ai-fd-head-cell" style={{ width: "15%" }}>
           Position
          </div>

          <div className="ai-fd-head-cell" style={{ width: "10%" }}>
            Grade
          </div>

          <div className="ai-fd-head-cell" style={{ width: "15%" }}>Total evaluations</div>
          <div className="ai-fd-head-cell" style={{ width: "10%" }}>Action</div>
         
        </div>
        {noData && <Nodata message="No teachers found" />}
        
            {teachers.length > 0 &&
            teachers.map((e, i) => (
            <div key={i} className="ai-fd-table-row">
              <div className="ai-fd-row-cell" style={{ width: "15%" }}>
                {e.name}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "20%" }}>
                {e.email}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "15%" }}>
                {e.subject ? e.subject : "-"}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "15%" }}>
                {e.position ? e.position : "-"}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "10%" }}>
                {e.grade ? e.grade : "-"}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "15%" }}>
                {e.total_papers}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "10%" }}>
                <button className="my-btn" style={{ backgroundColor: "#E0F5FE", color: "#01A7DE" }} onClick={() => navigate(`/school-management/teachers/papers`,{state:{teacher_name: e.name, school_name: school_name,user_id: e.id}})}>View</button>
              </div>
              
              
            </div>
          ))}
          
      </div>
      <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {teachers.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={teachers.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  teachers.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (teachers.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>


        </div>
       
    </div>
  )
}

export default Teachers